<template>
  <div class="page-title">
    {{sortBar.title}} <span class="small">{{sortBar.count}}</span>
    <div class="sort-field">
      Sort by:
      <b-form-select v-bind:value="queryParams.sortBy"
                     v-on:input="onChangeQueryParams({sortBy: $event})"
                     :options="sortBy">
      </b-form-select>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'sort-bar',
    props: ['sortBar'],
    data () {
      return {
        sortBy: ['Most Recently Added', 'Citations', 'Most Viewed', 'Altmetric'],
        queryParams: {
          sortBy: 'Most Recently Added'
        },
        defaultQueryParams: {
          sortBy: 'Most Recently Added'
        }
      }
    },
    methods: {
      onChangeQueryParams: function (queryParam) {
        // queryParams - is an object that is collect selected filters - it can be used for request to server or results filtering
        this.queryParams = Object.assign({}, this.queryParams, queryParam)
      }
    }
  }
</script>

<style lang="scss" scoped>
  span.small {
    margin-left: 20px;
  }
  .sort-field {
    margin-top: -5px;
    color: #999999;
    font-size: 12px;
    float: right;
    select {
      margin-left: 10px;
      padding-top: 2px;
      padding-bottom: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// SortBarComponent.vue?8d266e16